export const EDIT_DELIVERY_ADDRESS = 'EDIT_DELIVERY_ADDRESS'
export const NEW_DELIVERY_ADDRESS = 'NEW_DELIVERY_ADDRESS'
export const PICKUP_CONTACT_INFORMATION = 'PICKUP_CONTACT_INFORMATION'
